webpackJsonp(["ajax_loader"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
  // is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
  // is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
  // double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit');

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === (typeof console === 'undefined' ? 'undefined' : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch (e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch (e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js");

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0,
      i;

  for (i in namespace) {
    hash = (hash << 5) - hash + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy() {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/ajax-loader/ajax-loader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var log = (0, _debug2.default)("ajax-loader");

function init(element) {
	log("init", element);

	var options = {
		targetElement: element,
		rootPathname: element.dataset.ajaxLoaderRootPathname,
		indicatorSelector: element.dataset.ajaxLoaderIndicatorSelector,
		fetchLinksParentSelector: element.dataset.ajaxLoaderFetchLinksParentSelector,
		indicatorTemplateId: element.dataset.ajaxLoaderIndicatorTemplateId
	};

	var handlers = {
		fetchHandler: fetchPage.bind(null, options),
		// fetchPartialHandler : fetchPartial.bind(null, options),
		isInSameLongContent: isInPath.bind(null, options.rootPathname),
		getLinkToFetch: getLinkToFetch.bind(null, options)
	};

	var state = {
		href: window.location.href,
		submitting: false
	};

	window.addEventListener("click", delegatedClickHandler.bind(null, { options: options, handlers: handlers, state: state }));
	window.onpopstate = historyHandler.bind(null, { options: options, handlers: handlers, state: state });

	window.addEventListener("submit", delegatedSubmitHandler.bind(null, { state: state }));
}

function getTemplate(templateId) {
	return document.getElementById(templateId);
}

function getLinkToFetch(_ref, target) {
	var fetchLinksParentSelector = _ref.fetchLinksParentSelector,
	    rootPathname = _ref.rootPathname;

	var anchor = getTargetAnchor(target);

	if (anchor && isInPath(anchor.href, rootPathname) && isContainedBy(anchor, fetchLinksParentSelector)) {
		return anchor;
	}
}

function getTargetAnchor(target) {
	if (target.nodeName.toLowerCase() === "a") {
		return target;
	}
	return target.closest("a");
}

function isContainedBy(element, parentSelector) {
	return element.closest(parentSelector);
}

function isInPath(url, rootPathname) {
	return url && url.indexOf(rootPathname) !== -1;
}

function fetchPage(options, url) {
	var targetElement = options.targetElement,
	    indicatorSelector = options.indicatorSelector;


	showLoading({ options: options });

	return fetch(url).then(function (response) {
		if (response.ok) {
			return response.text();
		}
		return Promise.reject(response);
	}).then(function (html) {
		var parser = new DOMParser();
		var freshPage = parser.parseFromString(html, "text/html");
		var freshMain = freshPage.querySelector("main");
		var freshTitle = freshPage.title;

		var scripts = getScripts(freshMain);

		Array.from(targetElement.childNodes).filter(function (node) {
			var isElement = node.nodeType == 1;
			return !isElement || isElement && !node.matches(indicatorSelector);
		}).forEach(function (node) {
			node.remove();
		});
		Array.from(freshMain.childNodes).forEach(function (node) {
			targetElement.append(node);
		});

		Array.from(scripts).forEach(function (script) {
			loadScript(options, script.src);
		});

		document.title = freshTitle;

		exitLoading(options);

		return freshTitle;
	}).catch(function (error) {

		// fallback to updating location directly
		window.location = url;
		log("error", error);
	});
}

function fetchPartial(options, url) {
	var targetElement = options.targetElement,
	    containerId = options.containerId;


	return fetch(url).then(function (response) {
		if (response.ok) {
			return response.text();
		}
		return Promise.reject(response);
	}).then(function (html) {
		var parser = new DOMParser();
		var page = parser.parseFromString(html, "text/html");
		var partial = page.getElementById(containerId);

		Array.from(targetElement.childNodes).forEach(function (node) {
			node.remove();
		});
		Array.from(partial.childNodes).forEach(function (node) {
			targetElement.append(node);
		});

		return url;
	});
}

/*
	// close menu
	currentPath
	targetPath

	currentHash
	targetHash
	currentHashIsEmpty
	targetHashIsEmpty


	// new page
	currentPath != targetPath
		preventDefault
		pushHistory

	// same page
	currentPath == targetPath

		// scroll to h1
		targetHashIsEmpty
			preventDefault
			pushHistory

		// scroll
		currentHash != targetHash

		// rescroll
		currentHash == targetHash
*/
function getScripts(container) {
	var scriptsToLoad = container.getElementsByTagName("script");
	var scripts = [];
	Array.from(scriptsToLoad).forEach(function (script) {
		if (script.src != "") {
			scripts.push({ src: script.src });
		}
	});

	return scripts;
}

// AddThis widget is injected outside the main element
// Visibility updated based on presence of social share block
function updateShareWidget() {
	var hasSocialShareBlock = document.querySelector(".block-social-share") !== null;
	var addThisWidgetSelector = ".at-custom-side-wrapper";
	var doHideAddThis = !hasSocialShareBlock;

	Array.from(document.querySelectorAll(addThisWidgetSelector)).forEach(function (widget) {
		widget.hidden = doHideAddThis;
	});

	if (window.addthis) {
		window["addthis_share"].url = window.location.href;
		window["addthis_share"].title = window.document.title;
		window.addthis.toolbox(".addthis_toolbox");
	}
}

function loadScript(options, scriptSrc) {
	var targetElement = options.targetElement;

	var script = document.createElement("script");
	script.type = "text/javascript";
	script.src = scriptSrc;
	targetElement.append(script);
}

function delegatedClickHandler(_ref2, event) {
	var options = _ref2.options,
	    handlers = _ref2.handlers;

	log("click handled:");
	var targetElement = options.targetElement;


	var ajaxAnchorClicked = handlers.getLinkToFetch(event.target);

	// Prevent AJAX for mailto links
	if (ajaxAnchorClicked && ajaxAnchorClicked.href && /^(mailto|tel|sms|callto):/i.test(ajaxAnchorClicked.href)) {
		return;
	}

	if (ajaxAnchorClicked) {
		var href = ajaxAnchorClicked.href;
		var willUnhash = isSamePageWithoutHash(window.location.href, ajaxAnchorClicked.href);
		var doFetch = hasChangedPathOrQuery(window.location.href, ajaxAnchorClicked.href);

		if (willUnhash) {
			event.preventDefault();
			history.pushState({}, "", href);
			focusSection(targetElement, href);
		} else if (doFetch) {
			event.preventDefault();
			log("link hijacked", event, ajaxAnchorClicked, href);

			showLoading({ options: options, handlers: handlers });

			handlers.fetchHandler(href).then(function (freshTitle) {
				// let stateObj = { foo: "bar" };
				// get title from returned page
				history.pushState({}, freshTitle, href);
				focusSection(targetElement, href);
				updateShareWidget();
			});
		} else {
			log("same page: default permitted");
		}
	}
}

function delegatedSubmitHandler(_ref3, event) {
	var state = _ref3.state;


	if (event.target.matches("form[data-ajax-loader-partial]")) {

		event.preventDefault();
		log("submit caught", event);

		if (state.submitting) {
			return false;
		}

		state.submitting = true;

		var form = event.target;
		var containerId = form.dataset.ajaxLoaderPartialContainerId;
		var focusId = form.dataset.ajaxLoaderPartialFocusId;

		var action = new URL(form.action);
		var data = new FormData(form);
		// const initialSearch = new URLSearchParams(action.search);
		var search = new URLSearchParams([].concat(_toConsumableArray(data)));
		var url = "" + action.origin + action.pathname + "?" + search + action.hash;

		var srcElement = event.submitter;
		var srcElementName = srcElement.getAttribute("name");
		var srcElementValue = srcElement.value;

		if (action.origin === window.location.origin && action.pathname === window.location.pathname) {
			// non-destructively update window.location
			var existingSearchParams = new URLSearchParams(window.location.search);
			search.forEach(function (value, key) {
				if (existingSearchParams.has(key)) {
					existingSearchParams.delete(key);
				}
				existingSearchParams.append(key, value);
			});

			if (srcElementName && srcElementValue) {
				if (existingSearchParams.has(srcElementName)) {
					existingSearchParams.delete(srcElementName);
				}
				existingSearchParams.append(srcElementName, srcElementValue);
			}

			url = "" + action.origin + action.pathname + "?" + existingSearchParams + action.hash;
		}

		// todo hash for error fallback

		// Display spinner button loading
		form.classList.add("is-submitting");

		fetchPartial({
			targetElement: document.getElementById(containerId),
			containerId: containerId
		}, url).then(function () {
			// let stateObj = { foo: "bar" };
			history.pushState({}, "", url);

			window.setTimeout(function () {
				var focusTarget = document.getElementById(focusId);
				if (focusTarget) {
					focusTarget.focus();
					state.submitting = false;
					form.classList.remove("is-submitting");
				}
			}, 0);
		}).catch(function (error) {
			log("error", error);
			window.location = url;
		});
	}
}
function focusSection(ajaxElement, href) {
	var location = new URL(href);
	var hash = location.hash;

	window.setTimeout(function () {
		var hasHash = hash !== "";
		// Focus the h1 (or labelled section) to
		// cause screenreaders to read out the newly loaded content title
		var targetElement = document.querySelector(hasHash ? hash : "h1");
		targetElement.focus();

		scrollToAnchor(hasHash ? targetElement : ajaxElement);
	}, 0);
}

function scrollToAnchor(targetElement) {
	if (targetElement) {
		targetElement.scrollIntoView(true);
	} else {
		window.scroll({ top: 0, left: 0, behavior: "smooth" });
	}
}

function historyHandler(_ref4, event) {
	var options = _ref4.options,
	    handlers = _ref4.handlers,
	    state = _ref4.state;

	log("location: " + document.location, document.location, "event.state: " + JSON.stringify(event.state), event.state, state);

	var targetElement = options.targetElement;


	window.setTimeout(function () {
		var willUnhash = isSamePageWithoutHash(state.href, document.location);
		var doFetch = hasChangedPathOrQuery(state.href, document.location);
		if (willUnhash) {
			focusSection(targetElement, document.location.href);
		} else if (doFetch) {
			handlers.fetchHandler(document.location).then(function () {
				focusSection(targetElement, document.location.href);
			});
		}

		state.href = document.location.href;
	}, 0);
}

function hasChangedPathOrQuery(prevHref, newHref) {
	if (newHref === prevHref) {
		return false;
	}
	var prevLocation = new URL(prevHref);
	var newLocation = new URL(newHref);

	var searchChanged = newLocation.search !== prevLocation.search;
	var pathChanged = newLocation.pathname !== prevLocation.pathname;

	return searchChanged || pathChanged;
}

function isSamePageWithoutHash(prevHref, newHref) {
	var prevLocation = new URL(prevHref);
	var newLocation = new URL(newHref);
	if (prevLocation.pathname !== newLocation.pathname) {
		return false;
	}
	return newLocation.hash === "";
}

function showLoading(_ref5) {
	var options = _ref5.options,
	    handlers = _ref5.handlers;
	var targetElement = options.targetElement,
	    indicatorSelector = options.indicatorSelector;
	// const { getIndicatorTemplate } = handlers;

	var indicator = targetElement.querySelector(indicatorSelector);

	if (!indicator) {
		var template = getTemplate(options.indicatorTemplateId);
		var createdIndicator = template.content;
		targetElement.prepend(createdIndicator);
	} else {
		indicator.hidden = false;
	}
}

function exitLoading(options) {
	var targetElement = options.targetElement,
	    indicatorSelector = options.indicatorSelector;

	var indicator = targetElement.querySelector(indicatorSelector);

	if (indicator) {
		indicator.classList.add("is-exiting");

		indicator.addEventListener("transitionend", hideLoading);
		indicator.classList.add("is-exiting");

		function hideLoading() {
			indicator.classList.remove("is-exiting");
			indicator.hidden = true;
		}
	}
}

exports.default = init;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/ajax-loader/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ajaxLoader = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/ajax-loader/ajax-loader.js");

var _ajaxLoader2 = _interopRequireDefault(_ajaxLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = "[data-ajax-loader]";
var element = document.querySelector(ELEMENT_SELECTOR);

if (element) {
	(0, _ajaxLoader2.default)(element);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/critical.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/ajax-loader/index.js");

/***/ }),

/***/ "multi /tool/project/client/src/core/critical.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/critical.js");


/***/ })

},["multi /tool/project/client/src/core/critical.js"]);


// WEBPACK FOOTER //
// scripts/ajax_loader--e8a3c477972284f54c8e.js